/**
 * Hash router — Phase 4-2 / T11 (router slice).
 *
 * Tiny rune-backed router. Two routes only: conversations list ('list') and
 * thread view ('thread'). Hash is the only source of truth — no history API.
 *
 * Importers: src/App.svelte (reads router.state and calls router.start() in
 * onMount). Phase 4-3 components call navigateToThread / navigateToList.
 */

export type Route =
  | { name: 'list' }
  | { name: 'thread'; conversationId: string };

class Router {
  state = $state<Route>({ name: 'list' });
  private listener: (() => void) | null = null;

  start(): void {
    this.read();
    if (this.listener) return;
    this.listener = () => this.read();
    window.addEventListener('hashchange', this.listener);
  }

  stop(): void {
    if (!this.listener) return;
    window.removeEventListener('hashchange', this.listener);
    this.listener = null;
  }

  navigateToThread(conversationId: string): void {
    window.location.hash = `#/threads/${conversationId}`;
  }

  navigateToList(): void {
    window.location.hash = `#/conversations`;
  }

  private read(): void {
    const h = window.location.hash;
    const m = h.match(/^#\/threads\/([0-9a-fA-F-]+)$/);
    if (m && m[1]) {
      this.state = { name: 'thread', conversationId: m[1] };
    } else {
      this.state = { name: 'list' };
    }
  }
}

export const router = new Router();
